<template>
	<v-container class="field-show flex-grow-1" :class="{ 'px-0': $vuetify.breakpoint.smAndDown }">
		<v-card rounded="lg" class="py-4" min-height="50vh">
			<v-card-text>
				<div class="d-flex justify-center align-center mt-4 mx-2">
					<v-icon color="error">mdi-alert-octagon</v-icon>
					<v-divider vertical class="mx-2" />
					<p class="mt-0 mb-0">
						Warning! Do not perform any actions on this page unless you have been instructed to do so by support staff.
						Actions taken on this page can result in the loss of your data!
					</p>
				</div>
				<v-divider class="my-4" />
				<v-subheader>Data</v-subheader>
				<div class="space">
					<import-data-button buttonText="Import Sampling Collection(s)" class="d-block" />
					<delete-data-button class="d-block" />
				</div>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import DeleteDataButton from '@/components/common/DeleteDataButton.vue';
import ImportDataButton from '@/components/common/ImportDataButton.vue';

export default defineComponent({
	components: {
		ImportDataButton,
		DeleteDataButton,
	},
	setup() {
		return {};
	},
});
</script>

<style scoped>
.space > * + * {
	margin-top: 1rem;
}
</style>
